import { Col, Form, Input } from 'antd';
import React, { FC } from 'react'
import { PrefixGameMetaTypes } from '~types/prefixs'

interface GameMetaGroupProps {
    gameMeta?: Record<PrefixGameMetaTypes, string>
}
export const PGSlotGroup: FC<GameMetaGroupProps> = ({ gameMeta }) => {
    return (
        <>
            <Col xs={24} sm={24}>
                <Form.Item
                    name={["gameMeta", "secret"]}
                    label="Secret"
                    rules={[{ required: true, message: 'กรุณากรอก Secret!' }]}
                    hasFeedback>
                    <Input placeholder="Secret" inputMode="text" />
                </Form.Item>
            </Col>
        </>
    )
}
